import React from 'react'
import Form from 'react-bootstrap/Form'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Row from 'react-bootstrap/Row'
import { useFormik } from 'formik'
import { RequestorSchema } from '../../../utils/validation'
import { Link } from 'react-router-dom'

import {
  dataPortalTitle,
} from '../../../assets/i18n/i18n'
import { renderFormikError } from '../../../utils/helpers'
import { appConfig } from '../../../assets/customizations/config'

type RequestorProps = {
  initialValues: any;
  onSubmit: (values: any) => void;
}

const Requestor: React.FC<RequestorProps> = ({ initialValues, onSubmit }) => {

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: RequestorSchema,
    onSubmit: (values) => {
      onSubmit(values)
    },
    enableReinitialize: true
  })

  return (
    <Form noValidate onSubmit={formik.handleSubmit} className='formContainer'>
      <Row>
        <Form.Group as={Col} xs={12}>
          <fieldset>
            <legend className="visually-hidden">Who are you registering for?</legend>
            <Form.Check
              id='registeringMyself'
              type='radio'
              label={
                <label>
                 {appConfig.registration_label}
                </label>
              }
              checked={formik.values.type === 'self'}
              onChange={(event) => {
                setTimeout(() => formik.setFieldValue('type', 'self'))
                setTimeout(() => formik.setFieldTouched('type', true))
              }}
              isInvalid={!!formik.errors.type && !!formik.touched.type}
            />
            <Form.Check
              id='registeringGuardian'
              type='radio'
              label={<label>I am a legal guardian/poa registering on behalf of a member.</label>}
              checked={formik.values.type === 'proxy'}
              onChange={(event) => {
                setTimeout(() => formik.setFieldValue('type', 'proxy'))
                setTimeout(() => formik.setFieldTouched('type', true))
              }}
              isInvalid={!!formik.errors.type && !!formik.touched.type}
            />
            {formik.errors.type && formik.touched.type && (
              <Form.Text className='text-danger mb-3'>
                {renderFormikError(formik.errors.type)}
              </Form.Text>
            )}
          </fieldset>
        </Form.Group>
        {
          formik.values.type === 'proxy' && (
            <>
              <Form.Group as={Col} md={6} sm={12}>
                <Form.Label htmlFor='firstName'>Your First Name:</Form.Label>
                <Form.Control
                  id='firstName'
                  type='text'
                  name='firstName'
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={!!formik.errors.firstName && !!formik.touched.firstName}
                  aria-invalid={!!formik.errors.firstName && !!formik.touched.firstName}
                  aria-describedby={
                    formik.errors.firstName && formik.touched.firstName ? 'firstName-error' : ''}
                  aria-required="true"
                />

                <Form.Control.Feedback id="firstName-error" type="invalid" role="alert">
                  {renderFormikError(formik.errors.firstName)}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group as={Col} md={6} sm={12}>
                <Form.Label htmlFor='lastName'>Your Last Name:</Form.Label>
                <Form.Control
                  id='lastName'
                  type='text'
                  name='lastName'
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  isInvalid={!!formik.errors.lastName && !!formik.touched.lastName}
                  aria-invalid={!!formik.errors.lastName && !!formik.touched.lastName}
                  aria-describedby={formik.errors.lastName && formik.touched.lastName ? 'lastName-error' : ''}
                  aria-required="true"
                />
                <Form.Control.Feedback id="lastName-error" type="invalid" role="alert">
                  {renderFormikError(formik.errors.lastName)}
                </Form.Control.Feedback>
              </Form.Group>
            </>
          )
        }
        <Col xs={12}>
          <hr />
        </Col>
        <Col xs={12} className='mb-3'>
          <Form.Check
            type='checkbox'
            label={<label>I agree to the <Link to='/terms'>Member Terms and Conditions</Link>.</label>}
            checked={formik.values.acceptedTerms}
            name='acceptedTerms'
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            isInvalid={!!formik.errors.acceptedTerms && !!formik.touched.acceptedTerms}
          />
          {formik.errors.acceptedTerms && formik.touched.acceptedTerms && (
            <Form.Text className='text-danger mb-3'>
              {renderFormikError(formik.errors.acceptedTerms)}
            </Form.Text>
          )}
        </Col>
      </Row>
      <Button variant='primary' type='submit' disabled={!formik.isValid || !formik.values.acceptedTerms}>
        Next &gt;&gt;
      </Button>
    </Form>
  )
}

export default Requestor